import React, { useState } from "react";
import { Grid, withStyles, Tabs, Tab } from "@material-ui/core";
import { Link } from "react-router-dom";
import BarChart from "../../../../../../components/BarChart/index.js";

import {
  biospecimenProfile,
  palette,
  valueConfiguration,
  timePointArgumentConfiguration,
  argumentConfiguration,
  seriesSetting,
  tooltipConfig,
} from "../../../../../../bento/studyDetailData.js";
import TabPanel from "../../../../../../components/Tab/TabPanel.js";
// import { navigatedToDashboard } from '../../../utils/utils';
import BiospecimenProfileModal from "./biospecimen-profile-modal.js";
import { useBiospecimenProfileModal } from "./biospecimen-profile-modal-store.js";
import {
  BarChartWrapper,
  // Content,
  // DetailContainerHeader,
  // DetailContainerItems,
  // HeaderButton,
  // HeaderButtonLink,
  // HeaderButtonLinkNumber,
  // HeaderButtonLinkSpan,
  // HeaderButtonLinkText,
  // MarginTopTenGrid,
  // StyledTabs,
} from "./biospecimen-profile-styled.js";
import useDashboardTabs from "../../../../../dashTemplate/components/dashboard-tabs-store.js";
import { onClearAllAndSelectFacetValue } from "../../../../../dashTemplate/sideBar/BentoFilterUtils.js";

const tooltipContent = ({ argument, originalValue }) => (
  <div>
    <span style={{ fontWeight: 400, color: "#444444" }}>{argument}, </span>
    <span style={{ color: "#444444", fontWeight: 700 }}>{originalValue}</span>
  </div>
);

const BiospecimenProfile = ({ classes, data, studyShortName, studyId }) => {

  const [, { setIsModalOpen }] = useBiospecimenProfileModal();
  const [, actions] = useDashboardTabs();

  const [currentTab, setCurrentTab] = useState(0);

  const handleTabChange = (event, value) => {
    setCurrentTab(value);
  };

  // Check if data exists and has valid biospecimen information
  const hasData = data && Object.keys(data).length > 0;

  const tabCount = hasData
    ? biospecimenProfile.tabs.filter(
        (tab) => data[tab.value] && data[tab.value].length > 0,
      )
    : [];

  const linkToDashboard = () => {
    // TODO: Once local-find is enabled; dispatch(resetAllData()) from bento-core/local-find to RESET_LOCALFIND_ALL_DATA
    onClearAllAndSelectFacetValue('study_short_name', studyShortName);
    actions.changeCurrentTab(1);
  };

  const tabItem = (items) => (
    <Tabs
      value={currentTab}
      onChange={handleTabChange}
      className={classes.tabs}
      textColor="primary"
      TabIndicatorProps={{
        style: {
          backgroundColor: "#0296C9",
          height: "5px",
        },
      }}
    >
      {items.map((item, index) => (
        <Tab
          className={classes.tab}
          classes={{
            root: classes.tab,
            labelContainer: classes.labelContainer,
          }}
          label={item.label}
          key={index}
        />
      ))}
    </Tabs>
  );

  const renderTabContent = (item, index) => (
    <TabPanel index={item.index} value={currentTab} key={index}>
      <BarChartWrapper>
        <div
          onClick={async () => {
            await setIsModalOpen(true);
          }}
        >
          <BarChart
            data={data[item.value]}
            palette={palette}
            tooltipContent={tooltipContent}
            tooltipConfig={tooltipConfig}
            argument={
              item.label === "TIMEPOINT"
                ? timePointArgumentConfiguration
                : argumentConfiguration
            }
            value={valueConfiguration}
            seriesSetting={seriesSetting}
            size={{ maxHeight: 300, maxWidth: 300 }}
          />
        </div>
        <BiospecimenProfileModal
          biospecimenProfile={biospecimenProfile}
          data={data}
          studyShortName={studyShortName}
          studyId={studyId}
          handleTabChange={handleTabChange}
          currentTab={currentTab}
        />
      </BarChartWrapper>
    </TabPanel>
  );

  return (
    <Grid item lg={6} md={6} sm={12} xs={12}>
      <Grid container className={classes.detailContainerHL}>
        <Grid item xs={12}>
          <span className={classes.detailContainerHeader}>
            {" "}
            Biospecimen PROFILE{" "}
          </span>
        </Grid>
      </Grid>
      {tabCount !== undefined && tabCount.length > 0 ? (
        <>
          <Grid container>
            <div className={classes.headerButton}>
              <span className={classes.headerButtonLinkSpan}>
                <Link
                  className={classes.headerButtonLink}
                  to={(location) => ({ ...location, pathname: "/explore" })}
                  onClick={() => linkToDashboard()}
                >
                  <span className={classes.headerButtonLinkNumber}>
                    {data?.specimen_count || 0}
                  </span>
                  <span className={classes.headerButtonLinkText}>
                    Associated Biospecimens
                  </span>
                </Link>
              </span>
            </div>
          </Grid>
          <Grid item xs={12} className={classes.tabContainer}>
            {tabItem(biospecimenProfile.tabs)}
          </Grid>
          <Grid container className={classes.detailContainerItems}>
            {biospecimenProfile.tabs.map((item, index) =>
              renderTabContent(item, index)
            )}
          </Grid>
        </>
      ) : (
        <Grid container className={classes.detailContainerCL}>
          <Grid item xs={12} sm={10}>
            <div className={classes.content}>
              This study does not have any biospecimens
            </div>
          </Grid>
        </Grid>
      )}
    </Grid>
  );
};

const styles = (theme) => ({
  detailContainerHL: {
    paddingRight: "30px",
    marginRight: "30px",
  },
  detailContainerCL: {
    paddingTop: "2px",
    paddingRight: "30px",
    marginRight: "30px",
  },
  detailContainerHeader: {
    textTransform: "uppercase",
    fontFamily: theme.custom.fontFamilyInter,
    fontSize: "18px",
    letterSpacing: "0.017em",
    color: "#066D93",
    fontWeight: "500",
  },
  container: {
    fontFamily: "Raleway, sans-serif",
    paddingLeft: "33px",
    paddingRight: "33px",
    paddingBottom: "25px",
  },
  content: {
    fontSize: '16px',
    fontFamily: theme.custom.fontFamilyNunito,
    marginTop: '8px',
    fontWeight: 400,
    color: '#000'
  },
  tabHighlight: {
    color: "#0296c9",
    outline: "none !important",
  },
  tabContainer: {
    width: "300px",
    marginTop: "15px",
    padding: "0px 23px",
    marginBottom: "30px",
    borderBottom: "1px solid #42779A",
  },
  tab: {
    fontSize: "14px",
    fontWeight: 600,
    lineHeight: "19px",
    fontFamily: "Nunito Sans",
    minWidth: "120px",
    paddingLeft: "2px",
    padding: "0px !important",
    marginRight: "10px",
    textAlign: "center",
    color: "#446B79",
  },
  headerButton: {
    fontFamily: theme.custom.fontFamilySans,
    marginTop: "15px",
    textAlign: "center",
    height: "37px",
    background: "#E7E5E5",
    padding: "5px 0px 0px 8px",
    //border: '3px solid #81A6B9',
    width: "218px",
  },
  headerButtonLinkSpan: {
    fontFamily: theme.custom.fontFamilyInter,
    height: "60px",
    //background: '#F6F4F4',
    width: "200px",
    fontSize: "14px",
    cursor: "default",
    "&:hover": {
      cursor: "default",
    },
  },
  headerButtonLinkText: {
    fontFamily: theme.custom.fontFamilyInter,
    color: "#0B3556",
    fontWeight: "400",
    fontSize: "12px",
    lineHeight: "14px",
    textAlign: "center",
  },
  headerButtonLinkNumber: {
    fontFamily: theme.custom.fontFamilyInter,
    margin: "0px 8px 0px -8px",
    fontSize: "14px",
    fontWeight: "700",
    lineHeight: "14px",
    color: "#990099",
    borderBottom: "2px solid #990099",
  },
  headerButtonLink: {
    textDecoration: "none",
    lineHeight: "14px",
    fontSize: "12px",
    color: "#990099",
    "&:hover": {
      textDecoration: "none",
    },
  },
  tabs: {
    "& .Mui-selected": {
      color: "#000000",
      fontWeight: "600",
    },
    fontFamily: theme.custom.fontFamilyNunitoSansRegular,
  },
  helpfulDirectionText: {
    marginTop: "18px",
    fontFamily: "Roboto",
    fontWeight: 400,
    color: "#757575",
    fontSize: "13px",
    fontStyle: "italic",
  },
});

export default withStyles(styles, { withTheme: true })(BiospecimenProfile);
